import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  SellerProductReviewStatus,
  SellerProductReviewView,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateReviewStatusInput = {
  storeSlug: string;
  reviewId: string;
  status: SellerProductReviewStatus;
};

export function useUpdateReviewStatusMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateReviewStatusInput) =>
      apiJsonClient<SellerProductReviewView>(
        endpoints.seller.reviewById(input.reviewId),
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ status: input.status }),
        },
      ),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.seller.reviewsPrefix(variables.storeSlug),
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
